// mobieleapp/src/constants/ui.ts

export type IconSize = 'xsmall' | 'small' | 'default' | 'large' | 'xlarge';

export const ICON_SIZES: Record<IconSize, number> = {
  xsmall: 12,
  small: 16,
  default: 24,
  large: 32,
  xlarge: 45,
};

export type IconMargin = 'xsmall' | 'small' | 'default' | 'large' | 'xlarge';

export const ICON_MARGIN: Record<IconMargin, string> = {
  xsmall: '0',
  small: '0',
  default: '0',
  large: '0',
  xlarge: '0',
};

export type ButtonSize = 'xsmall' | 'small' | 'default' | 'large' | 'xlarge';

export type ButtonFill = 'clear' | 'outline' | 'solid' | 'default';

export type ButtonType = 'text' | 'icon' | 'icon-text' | 'icon-full';

export const BUTTON_SIZES: Record<ButtonSize, string> = {
  xsmall: 'h-6 text-xs px-2',
  small: 'h-8 text-sm px-3',
  default: 'h-10 text-base px-4',
  large: 'h-12 text-lg px-6',
  xlarge: 'h-14 text-xl px-8',
};

export const BUTTON_STYLES = {
  clear: 'bg-transparent text-primary border-0',
  outline: 'border border-primary text-primary bg-white',
  solid: 'bg-primary text-white',
  default: 'bg-gray-200 text-black',
};

export const BUTTON_PADDING: Record<ButtonSize, string> = {
  xsmall: '0.25rem',
  small: '0.5rem',
  default: '1rem',
  large: '1.5rem',
  xlarge: '0px',
};
